module.exports = __webpack_public_path__ + "img/icon-3.5b243202.svg";